import { render, staticRenderFns } from "./DataCourse.vue?vue&type=template&id=230ac050&scoped=true"
import script from "./DataCourse.vue?vue&type=script&lang=js"
export * from "./DataCourse.vue?vue&type=script&lang=js"
import style0 from "./DataCourse.vue?vue&type=style&index=0&id=230ac050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ac050",
  null
  
)

export default component.exports